module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 603
// module chunks = 0